
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $lfoFx = parcelRequire("lfoFx");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.isLoading ? "_1UtDYzKGUX" : "_1UtDYzZqHV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM4F84 _3138424F84 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            interactionName: "forge-content-tools-loading"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
Object.assign($ced39bfea5ef5993$export$9f275aff884e1431, {
    propTypes: {
        extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
        isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
    }
});



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $cozmU.useState)(null);
    const [isLoading, setLoading] = (0, $cozmU.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $cozmU.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $cozmU.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $cozmU.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $cozmU.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $cozmU.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            } // Instrument the presence of non-content 3P content-action apps so
            // their keys are folded into the page-load `connectAppKeys` telemetry.
            (0, $8wW9d.recordNonContentAppKeys)('content-tools', extensions.map((ext)=>ext?.id));
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("2cnQy"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("fXdww"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("kSxHE"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("3JEPO"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("6Q85T"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("gZjJO"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("kmFpW"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("5EvGJ"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("g9LKC"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("8vGTl"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("kQwWo"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("blvlr"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("2cnQy", function(module, exports) {

let $199f332f7fcdcf1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $199f332f7fcdcf1e$var$load("hUbK8"),
    $199f332f7fcdcf1e$var$load("LWh5V"),
    $199f332f7fcdcf1e$var$load("eNXrl"),
    $199f332f7fcdcf1e$var$load("2RkKX"),
    $199f332f7fcdcf1e$var$load("dZsGY"),
    $199f332f7fcdcf1e$var$load("1Gr4q"),
    $199f332f7fcdcf1e$var$load("1R53K"),
    $199f332f7fcdcf1e$var$load("anA6E"),
    $199f332f7fcdcf1e$var$load("7G12e"),
    $199f332f7fcdcf1e$var$load("8ORDr"),
    $199f332f7fcdcf1e$var$load("4m45y"),
    $199f332f7fcdcf1e$var$load("4AElS"),
    $199f332f7fcdcf1e$var$load("4XoWv"),
    $199f332f7fcdcf1e$var$load("59hV4"),
    $199f332f7fcdcf1e$var$load("kwaPJ"),
    $199f332f7fcdcf1e$var$load("3ayyN"),
    $199f332f7fcdcf1e$var$load("aLwQm"),
    $199f332f7fcdcf1e$var$load("2TRyz"),
    $199f332f7fcdcf1e$var$load("lXUHS"),
    $199f332f7fcdcf1e$var$load("gfZAh"),
    $199f332f7fcdcf1e$var$load("kE76L"),
    $199f332f7fcdcf1e$var$load("4x9Jx"),
    $199f332f7fcdcf1e$var$load("kHXvF"),
    $199f332f7fcdcf1e$var$load("ea3NB"),
    $199f332f7fcdcf1e$var$load("by9qp"),
    $199f332f7fcdcf1e$var$load("i6gwF"),
    $199f332f7fcdcf1e$var$load("fuOfV"),
    $199f332f7fcdcf1e$var$load("jL1Ke"),
    $199f332f7fcdcf1e$var$load("5MQ0D"),
    $199f332f7fcdcf1e$var$load("exBMi"),
    $199f332f7fcdcf1e$var$load("6vqGz"),
    $199f332f7fcdcf1e$var$load("iBJWz"),
    $199f332f7fcdcf1e$var$load("cvcNg"),
    $199f332f7fcdcf1e$var$load("iZR3N"),
    $199f332f7fcdcf1e$var$load("jXM1T"),
    $199f332f7fcdcf1e$var$load("6wr18"),
    $199f332f7fcdcf1e$var$load("4N1MY"),
    $199f332f7fcdcf1e$var$load("ffEVr"),
    $199f332f7fcdcf1e$var$load("gaT5l"),
    $199f332f7fcdcf1e$var$load("2Vm3g"),
    $199f332f7fcdcf1e$var$load("c6SfL"),
    $199f332f7fcdcf1e$var$load("4Hcen"),
    $199f332f7fcdcf1e$var$load("7jwjb"),
    $199f332f7fcdcf1e$var$load("cenKA"),
    $199f332f7fcdcf1e$var$load("hn3wf"),
    $199f332f7fcdcf1e$var$load("h4Nf7"),
    $199f332f7fcdcf1e$var$load("Wowvf"),
    $199f332f7fcdcf1e$var$load("lkxmG"),
    $199f332f7fcdcf1e$var$load("dFbDj"),
    $199f332f7fcdcf1e$var$load("hhss7"),
    $199f332f7fcdcf1e$var$load("fGNl7"),
    $199f332f7fcdcf1e$var$load("lnKog"),
    $199f332f7fcdcf1e$var$load("kT6dz"),
    $199f332f7fcdcf1e$var$load("aAWLw"),
    $199f332f7fcdcf1e$var$load("7EorR"),
    $199f332f7fcdcf1e$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("fXdww", function(module, exports) {

let $b9d6db373fb1500a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9d6db373fb1500a$var$load("hUbK8"),
    $b9d6db373fb1500a$var$load("LWh5V"),
    $b9d6db373fb1500a$var$load("eNXrl"),
    $b9d6db373fb1500a$var$load("2RkKX"),
    $b9d6db373fb1500a$var$load("dZsGY"),
    $b9d6db373fb1500a$var$load("1Gr4q"),
    $b9d6db373fb1500a$var$load("1R53K"),
    $b9d6db373fb1500a$var$load("anA6E"),
    $b9d6db373fb1500a$var$load("7G12e"),
    $b9d6db373fb1500a$var$load("8ORDr"),
    $b9d6db373fb1500a$var$load("4m45y"),
    $b9d6db373fb1500a$var$load("4AElS"),
    $b9d6db373fb1500a$var$load("4XoWv"),
    $b9d6db373fb1500a$var$load("59hV4"),
    $b9d6db373fb1500a$var$load("kwaPJ"),
    $b9d6db373fb1500a$var$load("3ayyN"),
    $b9d6db373fb1500a$var$load("aLwQm"),
    $b9d6db373fb1500a$var$load("2TRyz"),
    $b9d6db373fb1500a$var$load("lXUHS"),
    $b9d6db373fb1500a$var$load("gfZAh"),
    $b9d6db373fb1500a$var$load("kE76L"),
    $b9d6db373fb1500a$var$load("4x9Jx"),
    $b9d6db373fb1500a$var$load("kHXvF"),
    $b9d6db373fb1500a$var$load("ea3NB"),
    $b9d6db373fb1500a$var$load("by9qp"),
    $b9d6db373fb1500a$var$load("i6gwF"),
    $b9d6db373fb1500a$var$load("fuOfV"),
    $b9d6db373fb1500a$var$load("jL1Ke"),
    $b9d6db373fb1500a$var$load("5MQ0D"),
    $b9d6db373fb1500a$var$load("exBMi"),
    $b9d6db373fb1500a$var$load("6vqGz"),
    $b9d6db373fb1500a$var$load("iBJWz"),
    $b9d6db373fb1500a$var$load("cvcNg"),
    $b9d6db373fb1500a$var$load("iZR3N"),
    $b9d6db373fb1500a$var$load("jXM1T"),
    $b9d6db373fb1500a$var$load("6wr18"),
    $b9d6db373fb1500a$var$load("4N1MY"),
    $b9d6db373fb1500a$var$load("ffEVr"),
    $b9d6db373fb1500a$var$load("gaT5l"),
    $b9d6db373fb1500a$var$load("2Vm3g"),
    $b9d6db373fb1500a$var$load("c6SfL"),
    $b9d6db373fb1500a$var$load("4Hcen"),
    $b9d6db373fb1500a$var$load("7jwjb"),
    $b9d6db373fb1500a$var$load("cenKA"),
    $b9d6db373fb1500a$var$load("hn3wf"),
    $b9d6db373fb1500a$var$load("h4Nf7"),
    $b9d6db373fb1500a$var$load("Wowvf"),
    $b9d6db373fb1500a$var$load("lkxmG"),
    $b9d6db373fb1500a$var$load("dFbDj"),
    $b9d6db373fb1500a$var$load("hhss7"),
    $b9d6db373fb1500a$var$load("fGNl7"),
    $b9d6db373fb1500a$var$load("lnKog"),
    $b9d6db373fb1500a$var$load("kT6dz"),
    $b9d6db373fb1500a$var$load("aAWLw"),
    $b9d6db373fb1500a$var$load("7EorR"),
    $b9d6db373fb1500a$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("kSxHE", function(module, exports) {

let $f332fe842fe1d79a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f332fe842fe1d79a$var$load("hUbK8"),
    $f332fe842fe1d79a$var$load("LWh5V"),
    $f332fe842fe1d79a$var$load("eNXrl"),
    $f332fe842fe1d79a$var$load("2RkKX"),
    $f332fe842fe1d79a$var$load("dZsGY"),
    $f332fe842fe1d79a$var$load("1Gr4q"),
    $f332fe842fe1d79a$var$load("1R53K"),
    $f332fe842fe1d79a$var$load("anA6E"),
    $f332fe842fe1d79a$var$load("7G12e"),
    $f332fe842fe1d79a$var$load("8ORDr"),
    $f332fe842fe1d79a$var$load("4m45y"),
    $f332fe842fe1d79a$var$load("4AElS"),
    $f332fe842fe1d79a$var$load("4XoWv"),
    $f332fe842fe1d79a$var$load("59hV4"),
    $f332fe842fe1d79a$var$load("kwaPJ"),
    $f332fe842fe1d79a$var$load("3ayyN"),
    $f332fe842fe1d79a$var$load("aLwQm"),
    $f332fe842fe1d79a$var$load("2TRyz"),
    $f332fe842fe1d79a$var$load("lXUHS"),
    $f332fe842fe1d79a$var$load("gfZAh"),
    $f332fe842fe1d79a$var$load("kE76L"),
    $f332fe842fe1d79a$var$load("4x9Jx"),
    $f332fe842fe1d79a$var$load("kHXvF"),
    $f332fe842fe1d79a$var$load("ea3NB"),
    $f332fe842fe1d79a$var$load("by9qp"),
    $f332fe842fe1d79a$var$load("i6gwF"),
    $f332fe842fe1d79a$var$load("fuOfV"),
    $f332fe842fe1d79a$var$load("jL1Ke"),
    $f332fe842fe1d79a$var$load("5MQ0D"),
    $f332fe842fe1d79a$var$load("exBMi"),
    $f332fe842fe1d79a$var$load("6vqGz"),
    $f332fe842fe1d79a$var$load("iBJWz"),
    $f332fe842fe1d79a$var$load("cvcNg"),
    $f332fe842fe1d79a$var$load("iZR3N"),
    $f332fe842fe1d79a$var$load("jXM1T"),
    $f332fe842fe1d79a$var$load("6wr18"),
    $f332fe842fe1d79a$var$load("4N1MY"),
    $f332fe842fe1d79a$var$load("ffEVr"),
    $f332fe842fe1d79a$var$load("gaT5l"),
    $f332fe842fe1d79a$var$load("2Vm3g"),
    $f332fe842fe1d79a$var$load("c6SfL"),
    $f332fe842fe1d79a$var$load("4Hcen"),
    $f332fe842fe1d79a$var$load("7jwjb"),
    $f332fe842fe1d79a$var$load("cenKA"),
    $f332fe842fe1d79a$var$load("hn3wf"),
    $f332fe842fe1d79a$var$load("h4Nf7"),
    $f332fe842fe1d79a$var$load("Wowvf"),
    $f332fe842fe1d79a$var$load("lkxmG"),
    $f332fe842fe1d79a$var$load("dFbDj"),
    $f332fe842fe1d79a$var$load("hhss7"),
    $f332fe842fe1d79a$var$load("fGNl7"),
    $f332fe842fe1d79a$var$load("lnKog"),
    $f332fe842fe1d79a$var$load("kT6dz"),
    $f332fe842fe1d79a$var$load("aAWLw"),
    $f332fe842fe1d79a$var$load("7EorR"),
    $f332fe842fe1d79a$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("3JEPO", function(module, exports) {

let $2b853ff9b18579d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b853ff9b18579d7$var$load("7jwjb"),
    $2b853ff9b18579d7$var$load("cenKA"),
    $2b853ff9b18579d7$var$load("hUbK8"),
    $2b853ff9b18579d7$var$load("2RkKX"),
    $2b853ff9b18579d7$var$load("1Gr4q"),
    $2b853ff9b18579d7$var$load("1R53K"),
    $2b853ff9b18579d7$var$load("anA6E"),
    $2b853ff9b18579d7$var$load("7G12e"),
    $2b853ff9b18579d7$var$load("8ORDr"),
    $2b853ff9b18579d7$var$load("4m45y"),
    $2b853ff9b18579d7$var$load("4AElS"),
    $2b853ff9b18579d7$var$load("4XoWv"),
    $2b853ff9b18579d7$var$load("kwaPJ"),
    $2b853ff9b18579d7$var$load("3ayyN"),
    $2b853ff9b18579d7$var$load("aLwQm"),
    $2b853ff9b18579d7$var$load("2TRyz"),
    $2b853ff9b18579d7$var$load("lXUHS"),
    $2b853ff9b18579d7$var$load("4x9Jx"),
    $2b853ff9b18579d7$var$load("kHXvF"),
    $2b853ff9b18579d7$var$load("ea3NB"),
    $2b853ff9b18579d7$var$load("by9qp"),
    $2b853ff9b18579d7$var$load("i6gwF"),
    $2b853ff9b18579d7$var$load("exBMi"),
    $2b853ff9b18579d7$var$load("6vqGz"),
    $2b853ff9b18579d7$var$load("iBJWz"),
    $2b853ff9b18579d7$var$load("cvcNg"),
    $2b853ff9b18579d7$var$load("iZR3N"),
    $2b853ff9b18579d7$var$load("jXM1T"),
    $2b853ff9b18579d7$var$load("6wr18"),
    $2b853ff9b18579d7$var$load("4N1MY"),
    $2b853ff9b18579d7$var$load("ffEVr"),
    $2b853ff9b18579d7$var$load("gaT5l"),
    $2b853ff9b18579d7$var$load("2Vm3g"),
    $2b853ff9b18579d7$var$load("c6SfL"),
    $2b853ff9b18579d7$var$load("4Hcen"),
    $2b853ff9b18579d7$var$load("fGNl7"),
    $2b853ff9b18579d7$var$load("hn3wf"),
    $2b853ff9b18579d7$var$load("h4Nf7"),
    $2b853ff9b18579d7$var$load("Wowvf"),
    $2b853ff9b18579d7$var$load("lkxmG"),
    $2b853ff9b18579d7$var$load("dFbDj"),
    $2b853ff9b18579d7$var$load("hhss7"),
    $2b853ff9b18579d7$var$load("kT6dz"),
    $2b853ff9b18579d7$var$load("aAWLw"),
    $2b853ff9b18579d7$var$load("7EorR"),
    $2b853ff9b18579d7$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("6Q85T", function(module, exports) {

let $4fade0b8d457fd0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4fade0b8d457fd0c$var$load("7jwjb"),
    $4fade0b8d457fd0c$var$load("cenKA"),
    $4fade0b8d457fd0c$var$load("hUbK8"),
    $4fade0b8d457fd0c$var$load("2RkKX"),
    $4fade0b8d457fd0c$var$load("1Gr4q"),
    $4fade0b8d457fd0c$var$load("1R53K"),
    $4fade0b8d457fd0c$var$load("anA6E"),
    $4fade0b8d457fd0c$var$load("7G12e"),
    $4fade0b8d457fd0c$var$load("8ORDr"),
    $4fade0b8d457fd0c$var$load("4m45y"),
    $4fade0b8d457fd0c$var$load("4AElS"),
    $4fade0b8d457fd0c$var$load("4XoWv"),
    $4fade0b8d457fd0c$var$load("kwaPJ"),
    $4fade0b8d457fd0c$var$load("3ayyN"),
    $4fade0b8d457fd0c$var$load("aLwQm"),
    $4fade0b8d457fd0c$var$load("2TRyz"),
    $4fade0b8d457fd0c$var$load("lXUHS"),
    $4fade0b8d457fd0c$var$load("4x9Jx"),
    $4fade0b8d457fd0c$var$load("kHXvF"),
    $4fade0b8d457fd0c$var$load("ea3NB"),
    $4fade0b8d457fd0c$var$load("by9qp"),
    $4fade0b8d457fd0c$var$load("i6gwF"),
    $4fade0b8d457fd0c$var$load("exBMi"),
    $4fade0b8d457fd0c$var$load("6vqGz"),
    $4fade0b8d457fd0c$var$load("iBJWz"),
    $4fade0b8d457fd0c$var$load("cvcNg"),
    $4fade0b8d457fd0c$var$load("iZR3N"),
    $4fade0b8d457fd0c$var$load("jXM1T"),
    $4fade0b8d457fd0c$var$load("6wr18"),
    $4fade0b8d457fd0c$var$load("4N1MY"),
    $4fade0b8d457fd0c$var$load("ffEVr"),
    $4fade0b8d457fd0c$var$load("gaT5l"),
    $4fade0b8d457fd0c$var$load("2Vm3g"),
    $4fade0b8d457fd0c$var$load("c6SfL"),
    $4fade0b8d457fd0c$var$load("4Hcen"),
    $4fade0b8d457fd0c$var$load("fGNl7"),
    $4fade0b8d457fd0c$var$load("hn3wf"),
    $4fade0b8d457fd0c$var$load("h4Nf7"),
    $4fade0b8d457fd0c$var$load("Wowvf"),
    $4fade0b8d457fd0c$var$load("lkxmG"),
    $4fade0b8d457fd0c$var$load("dFbDj"),
    $4fade0b8d457fd0c$var$load("hhss7"),
    $4fade0b8d457fd0c$var$load("kT6dz"),
    $4fade0b8d457fd0c$var$load("aAWLw"),
    $4fade0b8d457fd0c$var$load("7EorR"),
    $4fade0b8d457fd0c$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("gZjJO", function(module, exports) {

let $c5e1a763e188a745$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5e1a763e188a745$var$load("7jwjb"),
    $c5e1a763e188a745$var$load("cenKA"),
    $c5e1a763e188a745$var$load("hUbK8"),
    $c5e1a763e188a745$var$load("2RkKX"),
    $c5e1a763e188a745$var$load("1Gr4q"),
    $c5e1a763e188a745$var$load("1R53K"),
    $c5e1a763e188a745$var$load("anA6E"),
    $c5e1a763e188a745$var$load("7G12e"),
    $c5e1a763e188a745$var$load("8ORDr"),
    $c5e1a763e188a745$var$load("4m45y"),
    $c5e1a763e188a745$var$load("4AElS"),
    $c5e1a763e188a745$var$load("4XoWv"),
    $c5e1a763e188a745$var$load("kwaPJ"),
    $c5e1a763e188a745$var$load("3ayyN"),
    $c5e1a763e188a745$var$load("aLwQm"),
    $c5e1a763e188a745$var$load("2TRyz"),
    $c5e1a763e188a745$var$load("lXUHS"),
    $c5e1a763e188a745$var$load("4x9Jx"),
    $c5e1a763e188a745$var$load("kHXvF"),
    $c5e1a763e188a745$var$load("ea3NB"),
    $c5e1a763e188a745$var$load("by9qp"),
    $c5e1a763e188a745$var$load("i6gwF"),
    $c5e1a763e188a745$var$load("exBMi"),
    $c5e1a763e188a745$var$load("6vqGz"),
    $c5e1a763e188a745$var$load("iBJWz"),
    $c5e1a763e188a745$var$load("cvcNg"),
    $c5e1a763e188a745$var$load("iZR3N"),
    $c5e1a763e188a745$var$load("jXM1T"),
    $c5e1a763e188a745$var$load("6wr18"),
    $c5e1a763e188a745$var$load("4N1MY"),
    $c5e1a763e188a745$var$load("ffEVr"),
    $c5e1a763e188a745$var$load("gaT5l"),
    $c5e1a763e188a745$var$load("2Vm3g"),
    $c5e1a763e188a745$var$load("c6SfL"),
    $c5e1a763e188a745$var$load("4Hcen"),
    $c5e1a763e188a745$var$load("fGNl7"),
    $c5e1a763e188a745$var$load("hn3wf"),
    $c5e1a763e188a745$var$load("h4Nf7"),
    $c5e1a763e188a745$var$load("Wowvf"),
    $c5e1a763e188a745$var$load("lkxmG"),
    $c5e1a763e188a745$var$load("dFbDj"),
    $c5e1a763e188a745$var$load("hhss7"),
    $c5e1a763e188a745$var$load("kT6dz"),
    $c5e1a763e188a745$var$load("aAWLw"),
    $c5e1a763e188a745$var$load("7EorR"),
    $c5e1a763e188a745$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("kmFpW", function(module, exports) {

let $ed35fd57278ff3cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ed35fd57278ff3cb$var$load("7jwjb"),
    $ed35fd57278ff3cb$var$load("cenKA"),
    $ed35fd57278ff3cb$var$load("hUbK8"),
    $ed35fd57278ff3cb$var$load("2RkKX"),
    $ed35fd57278ff3cb$var$load("1Gr4q"),
    $ed35fd57278ff3cb$var$load("1R53K"),
    $ed35fd57278ff3cb$var$load("anA6E"),
    $ed35fd57278ff3cb$var$load("7G12e"),
    $ed35fd57278ff3cb$var$load("8ORDr"),
    $ed35fd57278ff3cb$var$load("4m45y"),
    $ed35fd57278ff3cb$var$load("4AElS"),
    $ed35fd57278ff3cb$var$load("4XoWv"),
    $ed35fd57278ff3cb$var$load("kwaPJ"),
    $ed35fd57278ff3cb$var$load("3ayyN"),
    $ed35fd57278ff3cb$var$load("aLwQm"),
    $ed35fd57278ff3cb$var$load("2TRyz"),
    $ed35fd57278ff3cb$var$load("lXUHS"),
    $ed35fd57278ff3cb$var$load("4x9Jx"),
    $ed35fd57278ff3cb$var$load("kHXvF"),
    $ed35fd57278ff3cb$var$load("ea3NB"),
    $ed35fd57278ff3cb$var$load("by9qp"),
    $ed35fd57278ff3cb$var$load("i6gwF"),
    $ed35fd57278ff3cb$var$load("exBMi"),
    $ed35fd57278ff3cb$var$load("6vqGz"),
    $ed35fd57278ff3cb$var$load("iBJWz"),
    $ed35fd57278ff3cb$var$load("cvcNg"),
    $ed35fd57278ff3cb$var$load("iZR3N"),
    $ed35fd57278ff3cb$var$load("jXM1T"),
    $ed35fd57278ff3cb$var$load("6wr18"),
    $ed35fd57278ff3cb$var$load("4N1MY"),
    $ed35fd57278ff3cb$var$load("ffEVr"),
    $ed35fd57278ff3cb$var$load("gaT5l"),
    $ed35fd57278ff3cb$var$load("2Vm3g"),
    $ed35fd57278ff3cb$var$load("c6SfL"),
    $ed35fd57278ff3cb$var$load("4Hcen"),
    $ed35fd57278ff3cb$var$load("hn3wf"),
    $ed35fd57278ff3cb$var$load("h4Nf7"),
    $ed35fd57278ff3cb$var$load("Wowvf"),
    $ed35fd57278ff3cb$var$load("lkxmG"),
    $ed35fd57278ff3cb$var$load("dFbDj"),
    $ed35fd57278ff3cb$var$load("hhss7"),
    $ed35fd57278ff3cb$var$load("fGNl7"),
    $ed35fd57278ff3cb$var$load("lnKog"),
    $ed35fd57278ff3cb$var$load("kT6dz"),
    $ed35fd57278ff3cb$var$load("aAWLw"),
    $ed35fd57278ff3cb$var$load("7EorR"),
    $ed35fd57278ff3cb$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("5EvGJ", function(module, exports) {

let $41d944ca4adadae9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41d944ca4adadae9$var$load("hUbK8"),
    $41d944ca4adadae9$var$load("2RkKX"),
    $41d944ca4adadae9$var$load("dZsGY"),
    $41d944ca4adadae9$var$load("1Gr4q"),
    $41d944ca4adadae9$var$load("1R53K"),
    $41d944ca4adadae9$var$load("anA6E"),
    $41d944ca4adadae9$var$load("7G12e"),
    $41d944ca4adadae9$var$load("8ORDr"),
    $41d944ca4adadae9$var$load("4m45y"),
    $41d944ca4adadae9$var$load("4AElS"),
    $41d944ca4adadae9$var$load("4XoWv"),
    $41d944ca4adadae9$var$load("59hV4"),
    $41d944ca4adadae9$var$load("kwaPJ"),
    $41d944ca4adadae9$var$load("3ayyN"),
    $41d944ca4adadae9$var$load("aLwQm"),
    $41d944ca4adadae9$var$load("2TRyz"),
    $41d944ca4adadae9$var$load("lXUHS"),
    $41d944ca4adadae9$var$load("gfZAh"),
    $41d944ca4adadae9$var$load("kE76L"),
    $41d944ca4adadae9$var$load("4x9Jx"),
    $41d944ca4adadae9$var$load("kHXvF"),
    $41d944ca4adadae9$var$load("ea3NB"),
    $41d944ca4adadae9$var$load("by9qp"),
    $41d944ca4adadae9$var$load("i6gwF"),
    $41d944ca4adadae9$var$load("fuOfV"),
    $41d944ca4adadae9$var$load("jL1Ke"),
    $41d944ca4adadae9$var$load("5MQ0D"),
    $41d944ca4adadae9$var$load("exBMi"),
    $41d944ca4adadae9$var$load("6vqGz"),
    $41d944ca4adadae9$var$load("iBJWz"),
    $41d944ca4adadae9$var$load("cvcNg"),
    $41d944ca4adadae9$var$load("iZR3N"),
    $41d944ca4adadae9$var$load("jXM1T"),
    $41d944ca4adadae9$var$load("6wr18"),
    $41d944ca4adadae9$var$load("4N1MY"),
    $41d944ca4adadae9$var$load("ffEVr"),
    $41d944ca4adadae9$var$load("gaT5l"),
    $41d944ca4adadae9$var$load("2Vm3g"),
    $41d944ca4adadae9$var$load("c6SfL"),
    $41d944ca4adadae9$var$load("4Hcen"),
    $41d944ca4adadae9$var$load("7jwjb"),
    $41d944ca4adadae9$var$load("cenKA"),
    $41d944ca4adadae9$var$load("hn3wf"),
    $41d944ca4adadae9$var$load("h4Nf7"),
    $41d944ca4adadae9$var$load("Wowvf"),
    $41d944ca4adadae9$var$load("lkxmG"),
    $41d944ca4adadae9$var$load("dFbDj"),
    $41d944ca4adadae9$var$load("hhss7"),
    $41d944ca4adadae9$var$load("fGNl7"),
    $41d944ca4adadae9$var$load("lnKog"),
    $41d944ca4adadae9$var$load("kT6dz"),
    $41d944ca4adadae9$var$load("aAWLw"),
    $41d944ca4adadae9$var$load("7EorR"),
    $41d944ca4adadae9$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("g9LKC", function(module, exports) {

let $bc3286f31dda94d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc3286f31dda94d7$var$load("hUbK8"),
    $bc3286f31dda94d7$var$load("2RkKX"),
    $bc3286f31dda94d7$var$load("dZsGY"),
    $bc3286f31dda94d7$var$load("1Gr4q"),
    $bc3286f31dda94d7$var$load("1R53K"),
    $bc3286f31dda94d7$var$load("anA6E"),
    $bc3286f31dda94d7$var$load("7G12e"),
    $bc3286f31dda94d7$var$load("8ORDr"),
    $bc3286f31dda94d7$var$load("4m45y"),
    $bc3286f31dda94d7$var$load("4AElS"),
    $bc3286f31dda94d7$var$load("4XoWv"),
    $bc3286f31dda94d7$var$load("59hV4"),
    $bc3286f31dda94d7$var$load("kwaPJ"),
    $bc3286f31dda94d7$var$load("3ayyN"),
    $bc3286f31dda94d7$var$load("aLwQm"),
    $bc3286f31dda94d7$var$load("2TRyz"),
    $bc3286f31dda94d7$var$load("lXUHS"),
    $bc3286f31dda94d7$var$load("gfZAh"),
    $bc3286f31dda94d7$var$load("kE76L"),
    $bc3286f31dda94d7$var$load("4x9Jx"),
    $bc3286f31dda94d7$var$load("kHXvF"),
    $bc3286f31dda94d7$var$load("ea3NB"),
    $bc3286f31dda94d7$var$load("by9qp"),
    $bc3286f31dda94d7$var$load("i6gwF"),
    $bc3286f31dda94d7$var$load("fuOfV"),
    $bc3286f31dda94d7$var$load("jL1Ke"),
    $bc3286f31dda94d7$var$load("5MQ0D"),
    $bc3286f31dda94d7$var$load("exBMi"),
    $bc3286f31dda94d7$var$load("6vqGz"),
    $bc3286f31dda94d7$var$load("iBJWz"),
    $bc3286f31dda94d7$var$load("cvcNg"),
    $bc3286f31dda94d7$var$load("iZR3N"),
    $bc3286f31dda94d7$var$load("jXM1T"),
    $bc3286f31dda94d7$var$load("6wr18"),
    $bc3286f31dda94d7$var$load("4N1MY"),
    $bc3286f31dda94d7$var$load("ffEVr"),
    $bc3286f31dda94d7$var$load("gaT5l"),
    $bc3286f31dda94d7$var$load("2Vm3g"),
    $bc3286f31dda94d7$var$load("c6SfL"),
    $bc3286f31dda94d7$var$load("4Hcen"),
    $bc3286f31dda94d7$var$load("7jwjb"),
    $bc3286f31dda94d7$var$load("cenKA"),
    $bc3286f31dda94d7$var$load("hn3wf"),
    $bc3286f31dda94d7$var$load("h4Nf7"),
    $bc3286f31dda94d7$var$load("Wowvf"),
    $bc3286f31dda94d7$var$load("lkxmG"),
    $bc3286f31dda94d7$var$load("dFbDj"),
    $bc3286f31dda94d7$var$load("hhss7"),
    $bc3286f31dda94d7$var$load("fGNl7"),
    $bc3286f31dda94d7$var$load("lnKog"),
    $bc3286f31dda94d7$var$load("kT6dz"),
    $bc3286f31dda94d7$var$load("aAWLw"),
    $bc3286f31dda94d7$var$load("7EorR"),
    $bc3286f31dda94d7$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("8vGTl", function(module, exports) {

let $63227d5cce5594c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $63227d5cce5594c6$var$load("7jwjb"),
    $63227d5cce5594c6$var$load("cenKA"),
    $63227d5cce5594c6$var$load("hUbK8"),
    $63227d5cce5594c6$var$load("2RkKX"),
    $63227d5cce5594c6$var$load("1Gr4q"),
    $63227d5cce5594c6$var$load("1R53K"),
    $63227d5cce5594c6$var$load("anA6E"),
    $63227d5cce5594c6$var$load("7G12e"),
    $63227d5cce5594c6$var$load("8ORDr"),
    $63227d5cce5594c6$var$load("4m45y"),
    $63227d5cce5594c6$var$load("4AElS"),
    $63227d5cce5594c6$var$load("4XoWv"),
    $63227d5cce5594c6$var$load("kwaPJ"),
    $63227d5cce5594c6$var$load("3ayyN"),
    $63227d5cce5594c6$var$load("aLwQm"),
    $63227d5cce5594c6$var$load("2TRyz"),
    $63227d5cce5594c6$var$load("lXUHS"),
    $63227d5cce5594c6$var$load("4x9Jx"),
    $63227d5cce5594c6$var$load("kHXvF"),
    $63227d5cce5594c6$var$load("ea3NB"),
    $63227d5cce5594c6$var$load("by9qp"),
    $63227d5cce5594c6$var$load("i6gwF"),
    $63227d5cce5594c6$var$load("exBMi"),
    $63227d5cce5594c6$var$load("6vqGz"),
    $63227d5cce5594c6$var$load("iBJWz"),
    $63227d5cce5594c6$var$load("cvcNg"),
    $63227d5cce5594c6$var$load("iZR3N"),
    $63227d5cce5594c6$var$load("jXM1T"),
    $63227d5cce5594c6$var$load("6wr18"),
    $63227d5cce5594c6$var$load("4N1MY"),
    $63227d5cce5594c6$var$load("ffEVr"),
    $63227d5cce5594c6$var$load("gaT5l"),
    $63227d5cce5594c6$var$load("2Vm3g"),
    $63227d5cce5594c6$var$load("c6SfL"),
    $63227d5cce5594c6$var$load("4Hcen"),
    $63227d5cce5594c6$var$load("fGNl7"),
    $63227d5cce5594c6$var$load("hn3wf"),
    $63227d5cce5594c6$var$load("h4Nf7"),
    $63227d5cce5594c6$var$load("Wowvf"),
    $63227d5cce5594c6$var$load("lkxmG"),
    $63227d5cce5594c6$var$load("dFbDj"),
    $63227d5cce5594c6$var$load("hhss7"),
    $63227d5cce5594c6$var$load("kT6dz"),
    $63227d5cce5594c6$var$load("aAWLw"),
    $63227d5cce5594c6$var$load("7EorR"),
    $63227d5cce5594c6$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("kQwWo", function(module, exports) {

let $f2d23758577479b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2d23758577479b7$var$load("7jwjb"),
    $f2d23758577479b7$var$load("cenKA"),
    $f2d23758577479b7$var$load("hUbK8"),
    $f2d23758577479b7$var$load("2RkKX"),
    $f2d23758577479b7$var$load("1Gr4q"),
    $f2d23758577479b7$var$load("1R53K"),
    $f2d23758577479b7$var$load("anA6E"),
    $f2d23758577479b7$var$load("7G12e"),
    $f2d23758577479b7$var$load("8ORDr"),
    $f2d23758577479b7$var$load("4m45y"),
    $f2d23758577479b7$var$load("4AElS"),
    $f2d23758577479b7$var$load("4XoWv"),
    $f2d23758577479b7$var$load("kwaPJ"),
    $f2d23758577479b7$var$load("3ayyN"),
    $f2d23758577479b7$var$load("aLwQm"),
    $f2d23758577479b7$var$load("2TRyz"),
    $f2d23758577479b7$var$load("lXUHS"),
    $f2d23758577479b7$var$load("4x9Jx"),
    $f2d23758577479b7$var$load("kHXvF"),
    $f2d23758577479b7$var$load("ea3NB"),
    $f2d23758577479b7$var$load("by9qp"),
    $f2d23758577479b7$var$load("i6gwF"),
    $f2d23758577479b7$var$load("exBMi"),
    $f2d23758577479b7$var$load("6vqGz"),
    $f2d23758577479b7$var$load("iBJWz"),
    $f2d23758577479b7$var$load("cvcNg"),
    $f2d23758577479b7$var$load("iZR3N"),
    $f2d23758577479b7$var$load("jXM1T"),
    $f2d23758577479b7$var$load("6wr18"),
    $f2d23758577479b7$var$load("4N1MY"),
    $f2d23758577479b7$var$load("ffEVr"),
    $f2d23758577479b7$var$load("gaT5l"),
    $f2d23758577479b7$var$load("2Vm3g"),
    $f2d23758577479b7$var$load("c6SfL"),
    $f2d23758577479b7$var$load("4Hcen"),
    $f2d23758577479b7$var$load("hn3wf"),
    $f2d23758577479b7$var$load("h4Nf7"),
    $f2d23758577479b7$var$load("Wowvf"),
    $f2d23758577479b7$var$load("lkxmG"),
    $f2d23758577479b7$var$load("dFbDj"),
    $f2d23758577479b7$var$load("hhss7"),
    $f2d23758577479b7$var$load("fGNl7"),
    $f2d23758577479b7$var$load("lnKog"),
    $f2d23758577479b7$var$load("kT6dz"),
    $f2d23758577479b7$var$load("aAWLw"),
    $f2d23758577479b7$var$load("7EorR"),
    $f2d23758577479b7$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("blvlr", function(module, exports) {

let $8429f84f08c6724b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8429f84f08c6724b$var$load("7jwjb"),
    $8429f84f08c6724b$var$load("cenKA"),
    $8429f84f08c6724b$var$load("hUbK8"),
    $8429f84f08c6724b$var$load("2RkKX"),
    $8429f84f08c6724b$var$load("1Gr4q"),
    $8429f84f08c6724b$var$load("1R53K"),
    $8429f84f08c6724b$var$load("anA6E"),
    $8429f84f08c6724b$var$load("7G12e"),
    $8429f84f08c6724b$var$load("8ORDr"),
    $8429f84f08c6724b$var$load("4m45y"),
    $8429f84f08c6724b$var$load("4AElS"),
    $8429f84f08c6724b$var$load("4XoWv"),
    $8429f84f08c6724b$var$load("kwaPJ"),
    $8429f84f08c6724b$var$load("3ayyN"),
    $8429f84f08c6724b$var$load("aLwQm"),
    $8429f84f08c6724b$var$load("2TRyz"),
    $8429f84f08c6724b$var$load("lXUHS"),
    $8429f84f08c6724b$var$load("4x9Jx"),
    $8429f84f08c6724b$var$load("kHXvF"),
    $8429f84f08c6724b$var$load("ea3NB"),
    $8429f84f08c6724b$var$load("by9qp"),
    $8429f84f08c6724b$var$load("i6gwF"),
    $8429f84f08c6724b$var$load("exBMi"),
    $8429f84f08c6724b$var$load("6vqGz"),
    $8429f84f08c6724b$var$load("iBJWz"),
    $8429f84f08c6724b$var$load("cvcNg"),
    $8429f84f08c6724b$var$load("iZR3N"),
    $8429f84f08c6724b$var$load("jXM1T"),
    $8429f84f08c6724b$var$load("6wr18"),
    $8429f84f08c6724b$var$load("4N1MY"),
    $8429f84f08c6724b$var$load("ffEVr"),
    $8429f84f08c6724b$var$load("gaT5l"),
    $8429f84f08c6724b$var$load("2Vm3g"),
    $8429f84f08c6724b$var$load("c6SfL"),
    $8429f84f08c6724b$var$load("4Hcen"),
    $8429f84f08c6724b$var$load("hn3wf"),
    $8429f84f08c6724b$var$load("h4Nf7"),
    $8429f84f08c6724b$var$load("Wowvf"),
    $8429f84f08c6724b$var$load("lkxmG"),
    $8429f84f08c6724b$var$load("dFbDj"),
    $8429f84f08c6724b$var$load("hhss7"),
    $8429f84f08c6724b$var$load("fGNl7"),
    $8429f84f08c6724b$var$load("lnKog"),
    $8429f84f08c6724b$var$load("kT6dz"),
    $8429f84f08c6724b$var$load("aAWLw"),
    $8429f84f08c6724b$var$load("7EorR"),
    $8429f84f08c6724b$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("8wW9d", function(module, exports) {
/* eslint-disable check-react-ssr-usage/guard-browser-globals -- Client-only instrumentation; non-content 3P apps are fetched and rendered on the client, never SSRed. */ /**
 * Instrumentation for third-party (3P) apps rendered OUTSIDE of page content
 * (e.g. byline, page banner, context menu, content tools, web panels).
 *
 * Unlike content macros/extensions (which are indexed from the ADF document by
 * `ExtrensionIndexProvider`), these apps are fetched client-side via GraphQL
 * hooks (`useWebItemLocation` / `useExtensionList`) and are therefore invisible
 * to the content-based telemetry.
 *
 * Each non-content surface calls `recordNonContentAppKeys` when its apps resolve.
 * The collected keys are stashed on a dedicated window global and later folded
 * into the page-load metric's `connectAppKeys` attribute (React UFO
 * `extra_properties`) by `pageLoadEventPlugin`, so they land in the same RUM
 * dataset as content app keys.
 */ const $eb9f67592b61ef7c$export$8fb2b6127d91a721 = '::';
const $eb9f67592b61ef7c$export$75dfc4b4563b78a5 = (source, appKeys)=>{
    if (typeof window === 'undefined') return;
    const keys = window.__NON_CONTENT_APP_KEYS__ ?? new Set();
    for (const key of appKeys)if (key) keys.add(`${source}${$eb9f67592b61ef7c$export$8fb2b6127d91a721}${key}`);
    window.__NON_CONTENT_APP_KEYS__ = keys;
};
const $eb9f67592b61ef7c$export$40caeb9e96de3450 = ()=>typeof window === 'undefined' ? new Set() : window.__NON_CONTENT_APP_KEYS__ ?? new Set();
const $eb9f67592b61ef7c$export$d36eed915298b207 = ()=>{
    if (typeof window === 'undefined') return;
    window.__NON_CONTENT_APP_KEYS__ = new Set();
};
module.exports["recordNonContentAppKeys"] = $eb9f67592b61ef7c$export$75dfc4b4563b78a5;
module.exports["getNonContentAppKeys"] = $eb9f67592b61ef7c$export$40caeb9e96de3450;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("04qh3"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("04qh3", function(module, exports) {

let $00d4c153bc0a88fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00d4c153bc0a88fb$var$load("fGNl7"),
    $00d4c153bc0a88fb$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $6TaGl = parcelRequire("6TaGl");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $kSwu1.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $kSwu1.useIntl)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $cozmU.useState)('auto');
    const dropdownMenuContainerRef = (0, $cozmU.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $hekY6.default)([
            "_2XsHFMuFDC _4ouGXIoWWg",
            isExternalCollaborator && "_2XsHFMdnbC _4ouGXIoWWg"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $cozmU.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ForgeContentTools.5e178e45.js.map
